<template>
  <div class="icp-footer">
    <div class="icp-container">
      <img src="@/assets/imgs/guohui.png" alt="国徽" class="guohui-icon" />
      <a 
        href="https://beian.miit.gov.cn/" 
        target="_blank" 
        rel="noopener noreferrer"
        class="icp-link"
      >
        蜀ICP备2021019044号-12
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ICPFooter'
}
</script>

<style lang="scss" scoped>
.icp-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
  padding: 15px 0;
  
  background: rgba(30, 30, 47, 0.75);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.2);
  
  /* 确保文字完全居中 */
  display: flex;
  align-items: center;
  justify-content: center;
  
  .icp-container {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 14px;
    color: #fff; /* 稍微加深文字颜色 */
    
    .guohui-icon {
      width: 18px;
      height: 18px;
      object-fit: contain;
      
      /* 添加轻微阴影，让图标更立体 */
      filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.1));
    }
    
    .icp-link {
      color: #fff;
      text-decoration: none;
      transition: all 0.3s ease;
      
      &:hover {
        color: #409EFF;
        
        /* 悬停时轻微放大效果 */
        transform: scale(1.02);
      }
    }
  }
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .icp-footer {
    padding: 10px 0;
    
    .icp-container {
      font-size: 12px;
      gap: 6px;
      
      .guohui-icon {
        width: 16px;
        height: 16px;
      }
    }
  }
  
}

/* 小屏幕手机优化 */
@media screen and (max-width: 480px) {
  .icp-footer {
    padding: 8px 0;
    
    .icp-container {
      font-size: 11px;
      gap: 4px;
      
      .guohui-icon {
        width: 14px;
        height: 14px;
      }
    }
  }
}
</style>